import moment from "moment";
import { IAnalisesDeCredito } from "../../../../Interfaces/Vendas/GestaoAtendimentos/AnaliseDeCredito/AnaliseDeCreditoInterfaces";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export default function CardViewAnaliseDeCredito(props: IAnalisesDeCredito) {
    function CorDaAnalise(row: IAnalisesDeCredito) {
        if (row.DS_STATUS === "REPROVADA") {
            return "red";
        } else if (row.DS_STATUS === "APROVADA") {
            return "green";
        } else if (row.DS_STATUS === "PENDÊNCIA") {
            return "DarkMagenta";
        } else if (row.DS_STATUS === "EM ANÁLISE") {
            return "blue";
        }
    }

    return (
        <div className="card card-custom p-5 m-2">
            <div className=" d-flex flex-row flex-wrap g-4 justify-content-between align-items-start">
                <div className="d-flex flex-nowrap align-items-center justify-content-center">
                    <OverlayTrigger
                        overlay={
                            <Tooltip id="tooltip-disabled">ID Caso</Tooltip>
                        }
                    >
                        <div className="symbol symbol-45 symbol-light">
                            <div className="symbol-label">{props.ID_CASO}</div>
                        </div>
                    </OverlayTrigger>

                    <OverlayTrigger
                        overlay={
                            <Tooltip id="tooltip-disabled">Status</Tooltip>
                        }
                    >
                        <div
                            className=" rounded text-white ml-2 px-3 d-flex align-items-center justify-content-center"
                            style={{
                                height: "44px",
                                width: "100%",
                                backgroundColor: CorDaAnalise(props),
                            }}
                        >
                            <div className="symbol-label">
                                {props.DS_STATUS ? props.DS_STATUS : "-"}
                            </div>
                        </div>
                    </OverlayTrigger>
                    <OverlayTrigger
                        overlay={
                            <Tooltip id="tooltip-disabled">Sub-Status</Tooltip>
                        }
                    >
                        <div
                            className=" rounded text-white ml-2 px-3 d-flex align-items-center justify-content-center"
                            style={{
                                height: "44px",
                                width: "100%",
                                backgroundColor: CorDaAnalise(props),
                            }}
                        >
                            <div className="symbol-label">
                                {props.DS_ANALISE_CREDITO_STATUS
                                    ? props.DS_ANALISE_CREDITO_STATUS
                                    : "-"}
                            </div>
                        </div>
                    </OverlayTrigger>
                </div>
                <div className="d-flex flex-wrap g-2">
                    <div className="mb-2 mr-5 d-flex-inline flex-column align-items-center">
                        <div className="d-block font-weight-bold mb-1 text-center">
                            Última Alteração
                        </div>
                        <div className="label label-light-primary label-inline my-1">
                            {moment(props.DT_ULTIMA_ALTERACAO).format("lll")}
                        </div>
                    </div>
                </div>
            </div>
            <div className="d-flex flex-wrap justify-content-around flex g-5 my-2">
                <div className="d-flex flex-column">
                    <span>Responsável</span>
                    <span className="font-weight-bolder font-size-h5">
                        {props.DS_USUARIO_ANALISE}
                    </span>
                </div>
                <div className="d-flex flex-column">
                    <span>Validade</span>
                    <span className="font-weight-bolder font-size-h5">
                        {moment(props.DT_VALIDADE).format("lll")}
                    </span>
                    <span>{props.DS_EQUIPE_VENDAS_RESPONSAVEL}</span>
                </div>
                <div className="d-flex flex-column">
                    <span>Criação</span>
                    <span className="font-weight-bolder font-size-h5">
                        {moment(props.DT_CRIACAO).format("lll")}
                    </span>
                </div>
            </div>
            <hr />
        </div>
    );
}
